import React from 'react';

export const Search = ({ color = '#F8F8FD' }: { color: string }) => (
  <svg width="100%" height="100%" viewBox="0 0 56 57" fill="none">
    <circle cx="32" cy="25.8345" r="11" stroke={color} strokeWidth="2" />
    <path d="M12 42.8345L23.5 32.8345" stroke={color} strokeWidth="2" />
  </svg>
);
